// extracted by mini-css-extract-plugin
export const stripeCardElement = "credit-card-module--stripe-card-element--ioE4w";